import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { Box, Container, Grid, Skeleton } from '@mui/material';

export const PDPSkeleton = () => {
	return (
		<Container maxWidth={'xl'}>
			<Grid
				container
				// width='100%'
				display='flex'
				flexWrap='nowrap'
				sx={{
					// paddingLeft: '5%',
					// paddingRight: '5%',
					position: 'relative',
				}}
			>
				<Grid width='calc(100% - 400px)'>
					<FlexBox direction='column'>
						<FlexBox height='450px'>
							<Skeleton
								animation='wave'
								sx={{ transform: 'none' }}
								width={'calc(66% - 8px)'}
								height={'100%'}
							/>
							<Skeleton
								animation='wave'
								sx={{ transform: 'none', marginLeft: '8px' }}
								width={'34%'}
								height={'100%'}
							/>
						</FlexBox>
						<FlexBox mt='24px' height='60px'>
							<Skeleton
								sx={{ transform: 'none', marginLeft: '16px' }}
								animation='wave'
								width={'80px'}
								height={'100%'}
							/>
							<Skeleton
								sx={{ transform: 'none', marginLeft: '16px' }}
								animation='wave'
								width={'80px'}
								height={'100%'}
							/>
							<Skeleton
								sx={{ transform: 'none', marginLeft: '16px' }}
								animation='wave'
								width={'80px'}
								height={'100%'}
							/>
							<Skeleton
								sx={{ transform: 'none', marginLeft: '16px' }}
								animation='wave'
								width={'80px'}
								height={'100%'}
							/>
							<Skeleton
								sx={{ transform: 'none', marginLeft: '16px' }}
								animation='wave'
								width={'80px'}
								height={'100%'}
							/>
						</FlexBox>

						<FlexBox mt='50px' direction='column' height='102px'>
							<Skeleton
								animation='wave'
								height='34px'
								sx={{ width: '100%', transform: 'none' }}
							/>
							<Skeleton
								animation='wave'
								height='34px'
								sx={{ width: '70%', mt: '8px', transform: 'none' }}
							/>
						</FlexBox>
						<Skeleton
							height='150px'
							sx={{
								width: '100%',
								marginLeft: '16px',
								transform: 'none',
								mt: '24px',
							}}
						/>

						<Skeleton
							height='2000px'
							sx={{
								width: '100%',
								marginLeft: '16px',
								transform: 'none',
								mt: '24px',
							}}
						/>

						{/* <FlexBox mt='50px' width='100%' direction='column' height='200px' border='1px solid #E8E8E8'>
						<Skeleton
								height='100%'
								sx={{ width: '30%', transform: 'none' }}
							/>
							<FlexBox direction='column'>
							<Skeleton
								height='34px'
								sx={{ width: '70%', mt: '8px', transform: 'none' }}
							/>
														<Skeleton
								height='24px'
								sx={{ width: '40%', transform: 'none' }}
							/>
							</FlexBox>

						</FlexBox> */}
					</FlexBox>
					{/* <Skeleton sx={{pt: '75%', width: '100%'}}/> */}
				</Grid>
				<Grid
					container
					display='flex'
					alignSelf='flex-start'
					justifyContent='center'
					item
					width='440px'
					// height='600px'
					marginLeft='8px'
					// bgcolor={'#E8E8E8'}
					// border='1px solid #E8E8E8'
				>
					<FlexBox
						padding='32px'
						direction='column'
						width='100%'
						bgcolor='whitesmoke'
						height='100%'
					>
						<FlexBox direction='column' height='102px'>
							<Skeleton
								height='34px'
								sx={{ width: '100%', transform: 'none' }}
							/>
							<Skeleton
								height='34px'
								sx={{ width: '70%', mt: '8px', transform: 'none' }}
							/>
						</FlexBox>
						<FlexBox sx={{ mt: '24px' }} justifyContent='space-between'>
							<Skeleton
								height='24px'
								sx={{ width: '30%', transform: 'none' }}
							/>
							<Skeleton
								height='24px'
								sx={{ width: '40%', transform: 'none' }}
							/>
						</FlexBox>
						<Skeleton
							height='60px'
							sx={{
								mt: '24px',
								width: '90%',
								transform: 'none',
								borderRadius: '55px',
							}}
						/>
						<FlexBox sx={{ mt: '24px' }} justifyContent='space-between'>
							<Skeleton
								height='24px'
								sx={{ width: '35%', transform: 'none' }}
							/>
							<Skeleton
								height='24px'
								sx={{ width: '46%', transform: 'none' }}
							/>
						</FlexBox>
						<FlexBox sx={{ mt: '24px' }} justifyContent='space-between'>
							<Skeleton
								height='24px'
								sx={{ width: '25%', transform: 'none' }}
							/>
							<Skeleton
								height='24px'
								sx={{ width: '40%', transform: 'none' }}
							/>
						</FlexBox>
						<FlexBox sx={{ mt: '24px' }} justifyContent='space-between'>
							<Skeleton
								height='24px'
								sx={{ width: '28%', transform: 'none' }}
							/>
							<Skeleton
								height='24px'
								sx={{ width: '41%', transform: 'none' }}
							/>
						</FlexBox>
						<FlexBox
							sx={{ mt: '24px' }}
							justifyContent='space-between'
							overflow='hidden'
							flexDirection={'row-reverse'}
						>
							<Skeleton
								height='150px'
								sx={{ width: '200px', transform: 'none' }}
							/>
							<Skeleton
								height='150px'
								sx={{ width: '250px', marginLeft: '16px', transform: 'none' }}
							/>
						</FlexBox>
					</FlexBox>
					<Skeleton
						height='150px'
						sx={{
							width: '100%',
							marginLeft: '16px',
							transform: 'none',
							mt: '24px',
						}}
					/>
					<Skeleton
						height='150px'
						sx={{
							width: '100%',
							marginLeft: '16px',
							transform: 'none',
							mt: '24px',
						}}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};

export default PDPSkeleton;
